'use client';

/**
 * AppLoader - full-page loading screen shown on the very first paint
 * when the session and/or JS bundles are still hydrating.
 *
 * Triggered on 3G / slow networks. Renders a minimal, brand-coloured
 * spinner that auto-hides once the session status is no longer "loading".
 */
import { useEffect, useState } from 'react';
import { useSession } from 'next-auth/react';
import styles from './AppLoader.module.scss';

export default function AppLoader({ children }: { children: React.ReactNode }) {
  const { status } = useSession();
  // Give the session resolver a short grace period before showing content,
  // to avoid a momentary flicker on fast connections.
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (status !== 'loading') {
      // Tiny delay so CSS transition plays smoothly
      const t = setTimeout(() => setReady(true), 80);
      return () => clearTimeout(t);
    }
  }, [status]);

  return (
    <>
      {!ready && (
        <div className={styles.overlay} aria-label="Carregando…" role="status">
          <div className={styles.logoWrap}>
            <img src="/logo.png" alt="Autonomo" style={{ height: '36px', width: 'auto' }} />
          </div>
          <div className={styles.spinner} aria-hidden />
        </div>
      )}
      <div className={ready ? styles.contentVisible : styles.contentHidden}>
        {children}
      </div>
    </>
  );
}
